import React, { useMemo } from 'react';
import { Tabs } from 'antd';
import ViewReimbursements from '../../components/pages/manager/ViewReimbursements';

/**
 * Reusable component to show records for a given category (transactionReference)
 * Props:
 *   - category: string (e.g. 'INVOICE', 'EXPENSE', etc.)
 *   - my: '' | 'my' (for personal or all records)
 *   - tabLabels: {pending, approved, rejected}
 */
export default function CategoryRecordsView({ category, my = '', tabLabels = {}, recordsReloadKey }) {
  // Memoize props for performance
 
  return <ViewReimbursements my={my} filterCategory={category} status="rejected" recordsReloadKey={recordsReloadKey} />;
}
